import { useScreenVariant } from "../../branding/useScreenVariant";
import { ScreenVariant } from "../../branding/selectScreen";
import { BrandScope } from "../../branding/BrandScope";

import UpdatePasswordDefault from "./UpdatePasswordDefault";
import UpdatePasswordNotPortal from "./UpdatePasswordNotPortal";
import UpdatePasswordBranded from "./UpdatePasswordBranded";

function UpdatePassword() {
  const { variant, brand } = useScreenVariant();

  switch (variant) {
    case ScreenVariant.NOT_PORTAL:
      return <UpdatePasswordNotPortal />;
    case ScreenVariant.BRANDED:
      return (
        <BrandScope brand={brand}>
          <UpdatePasswordBranded />
        </BrandScope>
      );
    // TRADING cai no Default, como no comportamento atual.
    default:
      return <UpdatePasswordDefault />;
  }
}

export default UpdatePassword;
